import { StyleSheet } from '@react-pdf/renderer'
//
import '../utils/fonts'

const borderColor = '#000000'
const borderWidth = 0.5

export const styleConfig = {
	amountWidth: 25,
	tdThPaddingHorizontal: 3,
	tdThPaddingVertical: 3,
	borderColor: '#000000',
	borderWidth,
	fontSize: 7.2,
	borderStyle: `${borderWidth}px solid ${borderColor}`,
	fullWidth: 190,
	fullHeight: 277,
	margin: 10,
}

const styles = StyleSheet.create({
	body: {
		paddingHorizontal: `${styleConfig?.margin}mm`,
		paddingTop: `${styleConfig?.margin - 2}mm`,
		paddingBottom: `${styleConfig?.margin - 3}mm`,
	},

	title: {
		fontSize: 21,
		textAlign: 'center',
		fontFamily: 'Inter',
	},
	subtitle: {
		fontSize: 10,
		textAlign: 'center',
		marginBottom: 40,
	},
	image: {
		marginVertical: 15,
		marginHorizontal: 'auto',
		width: 200,
	},
	graph: {
		marginVertical: 15,
		marginHorizontal: 'auto',
		width: 350,
	},
})

export default styles
